<template>
  <div>
    <el-drawer
      :title="title"
      :visible.sync="drawer"
      size="80%"
      :wrapperClosable="false"
    >
      <div class="form-center" v-loading="loading">
        <el-form
          :model="form"
          ref="form"
          label-width="140px"
          :rules="rules"
          :disabled="disabled"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="价格表名称" prop="PriceName">
                <el-input
                  v-model="form.PriceName"
                  placeholder="请输入价格表名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否峰谷价" prop="IsLadderPrice">
                <el-radio-group
                  v-model="form.IsLadderPrice"
                  @change="
                    () => {
                      this.form.Price = ''
                      this.form.list = []
                    }
                  "
                >
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="form.IsLadderPrice === false">
              <el-form-item label="非峰谷价格" prop="Price">
                <el-input-number
                  v-model="form.Price"
                  :precision="2"
                  :step="0.1"
                  :min="0"
                  placeholder="请输入非峰谷价格"
                  style="width: 100%; text-align-last: left"
                  controls-position="right"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="按月/日导入数据" prop="DataType">
                <SelectDicValue
                  ref="DataType"
                  code="DataType"
                  v-model="form.DataType"
                ></SelectDicValue>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="描述" prop="Remark">
                <el-input
                  v-model="form.Remark"
                  placeholder=""
                  type="textarea"
                  rows="3"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="line-height: 30px" v-if="form.IsLadderPrice">
          <el-button type="primary" @click="addList" v-if="!disabled"
            >添加行</el-button
          >
        </div>
        <el-table
          v-if="form.IsLadderPrice"
          :data="form.list.filter((item) => !item.isDetele)"
          ref="dialogTable"
          style="width: 100%"
          height="calc(100% - 160px)"
        >
          <el-table-column label="序号" width="50" type="index">
          </el-table-column>

          <el-table-column label="名称" prop="StageName" sortable>
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.StageName"
                placeholder="请输入名称"
                style="width: 100%"
              ></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column label="阶段数量" align="center" prop="StageName" sortable>
          </el-table-column> -->
          <el-table-column label="价格" prop="StagePrice" sortable>
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.StagePrice"
                :precision="2"
                :step="0.1"
                :min="0"
                placeholder="请输入价格"
                style="width: 100%; text-align-last: left"
                controls-position="right"
              ></el-input-number>
            </template>
          </el-table-column>

          <el-table-column label="描述" prop="StageRamrk">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.StageRamrk"
                placeholder="请输入描述"
                type="textarea"
                rows="1"
                resize="none"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            align="center"
            prop="op"
            width="80px"
            v-if="!disabled"
          >
            <template slot-scope="scope">
              <el-popconfirm
                title="确认删除吗？"
                @confirm="deteleList(scope.row)"
              >
                <el-button
                  slot="reference"
                  type="text"
                  style="color: #f78989"
                  size="mini"
                  >删除</el-button
                >
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer" v-loading="loading">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSubmit" v-if="!disabled"
          >保存</el-button
        >
      </div>
    </el-drawer>
  </div>
</template>
<script>
import SelectDicValue from '@/components/DicValue/SelectDicValue.vue'
export default {
  data() {
    return {
      title: '',
      loading: false,

      RoleList: [],
      tD_InStorDetails: [],
      form: {
        PriceName: '',
        IsLadderPrice: null,
        Price: '',
        Remark: '',
        DataType: '',
        list: [],
      },
      rules: {
        PriceName: [
          { required: true, message: '请输入价格表名称', trigger: 'blur' },
        ],
        Price: [
          { required: true, message: '请输入价格', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value < 0) {
                callback(new Error('价格不能为负数'))
              } else {
                callback()
              }
            },
          },
        ],
        IsLadderPrice: [
          { required: true, message: '请选择是否峰谷价', trigger: 'change' },
        ],
        DataType: [
          {
            required: true,
            message: '请选择按月/日导入数据',
            trigger: 'change',
          },
        ],
      },
      drawer: false,
      disabled: false,
      row: {},
    }
  },
  props: {},
  components: { SelectDicValue },
  methods: {
    deteleList(row) {
      this.$set(row, 'isDetele', true)
    },
    StagePriceChange(num, row) {
      if (Number(num) < 0) {
        this.$notify.error('价格不能为负数')
        this.$set(row, 'StagePrice', 0)
      }
    },

    addList() {
      this.$set(this.form.list, this.form.list.length, {
        StageName: '',
        StagePrice: '',
        StageRamrk: '',
        isDetele: false,
        // StageQty
      })
    },

    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return this.$notify.error('请检查输入项')
        }
        if (this.form.IsLadderPrice) {
          let list = this.form.list.filter((item) => !item.isDetele)
          if (list.length == 0) {
            return this.$notify.error('请添加价格表信息')
          }
          let every = list.every((item) => {
            return item.StageName && Number(item.StagePrice) > -1
          })
          if (!every) {
            return this.$notify.error('请检查价格表信息是否填写完整')
          }
          let deletdList = this.form.list.filter((item) => item.isDetele)
          let arr = deletdList.filter((item) => item.Id).map((item) => item.Id)
          this.loading = true
          let flag = true
          if (arr.length > 0) {
            await this.$http
              .post('/Base/Base_ElectricityPriceItem/DeleteData', arr)
              .then((res) => {
                if (res.Success) {
                  flag = true
                  // this.$notify.success("删除成功");
                } else {
                  flag = false
                  this.loading = false
                  this.$notify.error(res.Msg)
                }
              })
              .catch(() => {
                flag = false
                this.loading = false
              })
          }
          if (!flag) {
            return
          }
        }
        this.loading = true
        this.$http
          .post('/Base/Base_ElectricityPrice/SaveData', {
            ...this.form,
            list: this.form.list.filter((item) => !item.isDetele),
          })
          .then((resJson) => {
            this.loading = false

            if (resJson.Success) {
              this.$notify.success('操作成功!')
              this.$emit('success')
              this.close()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
      })
    },
    openForm(title, row = {}, disabled = false) {
      this.drawer = true
      this.disabled = disabled
      // this.getRoleList();
      this.row = row
      this.form = {
        PriceName: '',
        IsLadderPrice: null,
        Price: '',
        Remark: '',
        DataType: '',
        list: [],
      }

      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.title = title
      if (row.Id) {
        this.getInfo(row.Id)
      }
    },
    getInfo(id) {
      this.loading = true
      this.$http
        .post('/Base/Base_ElectricityPrice/GetTheData', { id: id })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            resJson.Data.list.forEach((item) => {
              this.$set(item, 'isDetele', false)
            })
            this.form = resJson.Data
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    close() {
      this.drawer = false
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin: 0;
  padding: 20px;
}
.form-center {
  height: calc(100vh - 120px);
  padding: 20px;
}
.footer {
  height: 40px;
  line-height: 40px;
  text-align: right;
  padding: 0 20px;
}
::v-deep .avatar-uploader .el-upload {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 65px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
</style>
